export { default } from "./src/image";
export type { UniformImageProps } from "./src/image";
